import {AfterViewInit, Component, ElementRef, ViewChild} from '@angular/core';

let faceapi: any;
@Component({
  selector: 'app-camera-testing',
  templateUrl: './camera-testing.component.html',
  styleUrls: ['./camera-testing.component.css']
})
export class CameraTestingComponent implements AfterViewInit{
  @ViewChild('video') video: ElementRef;
  @ViewChild('canvas') canvas: ElementRef;
  @ViewChild('downloadLink') downloadLink: ElementRef;
   faceDictated: boolean = false;
   message: string = 'Please look at the camera and click the Capture button to take a picture of your face.';

  ngAfterViewInit() {
    this.startCamera();
    this.loadFaceApiModels();
  }

  startCamera() {
    navigator.mediaDevices.getUserMedia({ video: {} })
        .then(stream => {
          this.video.nativeElement.srcObject = stream;
        })
        .catch(err => console.error("Error accessing camera: ", err));
  }

  async loadFaceApiModels() {
    if (!faceapi) {
      faceapi = await import('face-api.js');
    }
    await faceapi.nets.tinyFaceDetector.loadFromUri('/assets/models');
    await faceapi.nets.faceLandmark68Net.loadFromUri('/assets/models');
    await faceapi.nets.faceRecognitionNet.loadFromUri('/assets/models');
    await faceapi.nets.faceExpressionNet.loadFromUri('/assets/models');
  }

  async capture() {
    const canvas = this.canvas.nativeElement;
    const context = canvas.getContext('2d');
    context.drawImage(this.video.nativeElement, 0, 0, canvas.width, canvas.height);

    // Detect faces
    const detections = await faceapi.detectAllFaces(canvas, new faceapi.TinyFaceDetectorOptions());
    const detectionsWithLandmarks = await faceapi.detectAllFaces(canvas, new faceapi.TinyFaceDetectorOptions()).withFaceLandmarks();


    if (detections.length === 0) {
      this.message = 'No face detected. Please try again.';
      this.faceDictated = false;
      return;
    }
    if (detections.length > 1) {
        this.message = 'Multiple faces detected. Please try again.';
        this.faceDictated = false;
        return;
    }

    // Check if face is blurred
    if (this.isFaceBlurred(context, detections[0])) {
      this.faceDictated = false;
      this.message = 'Face is blurred. Please try again.';
      return;
    }

    // Convert the captured image to a data URL
    const dataUrl = canvas.toDataURL('image/png');

    this.message ='Success';
    this.faceDictated = true;
    console.log(dataUrl)
    // Set the download link with the data URL
    this.downloadLink.nativeElement.href = dataUrl;
    this.downloadLink.nativeElement.download = 'captured-image.png';
    this.downloadLink.nativeElement.innerText = 'Save Image';
  }
  isFaceBlurred(context: CanvasRenderingContext2D, detection: any): boolean {
    const box = detection.box;
    const imageData = context.getImageData(box.x, box.y, box.width, box.height);
    const grayImageData = this.convertToGrayscale(imageData);
    const blurValue = this.calculateBlur(grayImageData);
    const blurThreshold = 100; // Adjust threshold as needed
    return blurValue < blurThreshold;
  }

  convertToGrayscale(imageData: ImageData): ImageData {
    const data = imageData.data;
    for (let i = 0; i < data.length; i += 4) {
      const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
      data[i] = data[i + 1] = data[i + 2] = avg;
    }
    return imageData;
  }

  calculateBlur(imageData: ImageData): number {
    const data = imageData.data;
    let sum = 0;
    for (let i = 0; i < data.length; i += 4) {
      sum += data[i];
    }
    const avg = sum / (data.length / 4);
    let variance = 0;
    for (let i = 0; i < data.length; i += 4) {
      variance += (data[i] - avg) ** 2;
    }
    return variance / (data.length / 4);
  }

}
